import Link from 'next/link'

import type { LearningGroup } from 'types/entities'

import ArrowAltRightIcon from 'assets/icons/arrow-alt-right.svg'

const LearningGroupListCard = ({
  learningGroup,
}: {
  learningGroup: LearningGroup
}) => {
  return (
    <div className="shadow-lg bg-white rounded-md mb-3">
      <Link
        href={`/learning-group/${learningGroup.id}?from=learning-group-list`}
        passHref
      >
        <a
          href={`/learning-group/${learningGroup.id}?from=learning-group-list`}
        >
          <div className="px-4 py-3">
            <h2 className="text-lg font-semibold break-all">
              {learningGroup.name}
            </h2>
            <div className="flex justify-between mt-4">
              <span className="text-gray-500">
                {learningGroup.totalStudents ?? 0} Murid
              </span>
              <span className="text-gray-500">
                Kelas {learningGroup.class} · {learningGroup.schoolYear}
              </span>
            </div>
          </div>
        </a>
      </Link>
      {learningGroup.totalStudentsUnscored > 0 && (
        <>
          <hr />
          <Link href="/assessment/me" passHref>
            <a href="/assessment/me">
              <div className="px-4 py-3 flex justify-between">
                <div className="flex items-center">
                  <div
                    className="w-2 h-2 mr-2 bg-interactive-critical-default rounded-full"
                    role="presentation"
                  ></div>
                  <span className="text-sm">
                    {learningGroup.totalStudentsUnscored} uraian murid belum
                    diperiksa
                  </span>
                </div>
                <ArrowAltRightIcon width={12} height={12} />
              </div>
            </a>
          </Link>
        </>
      )}
    </div>
  )
}

export default LearningGroupListCard
